import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { SustainabilityFiltersValues } from '@/utils/constants'

export const mapSustainabilityFiltersSaveParams = (
    validActiveFilters: SustainabilityFiltersValues
) => {
    const timelineValue = parseTimelineFilter(validActiveFilters.timeline)

    const baseParams = {
        nodeIds: validActiveFilters.node,
        commodityTypeIds: validActiveFilters.commodity,
        facilityIds: validActiveFilters.facility,
        contractIds: validActiveFilters.contract,
        tagIds: validActiveFilters.tag,
        meterIds: validActiveFilters.meter,
    }

    if (validActiveFilters.timeline.type === 'is') {
        return {
            ...baseParams,
            timeline: validActiveFilters.timeline.value,
        }
    } else {
        return {
            ...baseParams,
            startDate: timelineValue.startDate,
            endDate: timelineValue.endDate,
        }
    }
}
